import React from "react";
import axios from "axios";
import queryString from "query-string";
import styles from "./ForgotPassword.module.css";
import { IoEye } from "react-icons/io5";
import { IoMdEyeOff } from "react-icons/io";

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      password2: null,
      message: null,
      flag: false,
      isPasswordVisibleForm1: false,
      isPasswordVisibleForm2: false,
    };
    this.handleToggleForm1Password = this.handleToggleForm1Password.bind(this);
    this.handleToggleForm2Password = this.handleToggleForm2Password.bind(this);
  }

  handleToggleForm1Password() {
    this.setState((prevState) => ({
      isPasswordVisibleForm1: !prevState.isPasswordVisibleForm1,
    }));
  }

  // Toggle method for Form 2
  handleToggleForm2Password() {
    this.setState((prevState) => ({
      isPasswordVisibleForm2: !prevState.isPasswordVisibleForm2,
    }));
  }

  alignPassword = (password_1, password_2) => {
    if (password_2) {
      if (password_1 !== password_2 && this.state.flag === false) {
        this.setState({ message: "Passwords do not match!", flag: true });
      } else if (password_1 === password_2 && this.state.flag === true) {
        this.setState({ flag: false, message: null });
      }
    }
  };

  resetPassword = (e, token, password) => {
    e.preventDefault();
    token = queryString.parse(token).token;
    if (!password || password.trim() === "") {
      this.setState({ message: "Password cannot be empty" });
      return; // Exit early if password is empty
    }
    if (password.length >= 7) {
      axios
        .put("/login/change-password/confirmation", { token, password })
        .then(() => {
          window.location.href = "/";
        })
        .catch((e) => this.setState({ message: e.response.data.error }));
    } else {
      this.setState({ message: "Password must be greater that 7 characters" });
    }
  };

  render() {
    this.alignPassword(this.state.password, this.state.password2);
    return (
      <div className={styles.main}>
        <div className={styles.green}>
          <a href="/">
            <img
              className={styles.logo}
              src="https://treo.s3.us-east-2.amazonaws.com/assets/Logo_White.png"
              alt="Logo"
              href={"/"}
            />
          </a>
          <div className={styles.headingContainer}>
            <h1 className={styles.heading1}>
              Change is Possible with Treo Wellness
            </h1>
            <h2 className={styles.heading2}>
              We are your whole-person wellbeing app designed to help you
              discover your healthy lifestyle. Get started today!
            </h2>
          </div>
        </div>
        <div className={styles.white}>
          <div className={styles.formSelector}>
            <div className={styles.passwordConfirmOuterContainer}>
              <form
                onSubmit={(e) =>
                  this.resetPassword(
                    e,
                    this.props.location.search,
                    this.state.password2
                  )
                }
              >
                <p className={styles.formTitle}>Reset Password</p>
                <div className={styles.passwordConfirmContainer}>
                  {this.state.message !== null && (
                    <p className={styles.errorMessage}>{this.state.message}</p>
                  )}
                  <p className={styles.lightText}>
                    Enter your new password in the form below. Password must be
                    greater that 7 characters.
                  </p>

                  <div
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <label htmlFor="password1">New Password</label>
                    <input
                      type={
                        this.state.isPasswordVisibleForm1 ? "text" : "password"
                      }
                      placeholder="New Password"
                      value={this.state.password}
                      onChange={(event) =>
                        this.setState({ password: event.target.value })
                      }
                    />
                    <button
                      type="button"
                      onClick={this.handleToggleForm1Password}
                      // Positioning the button on top-right of the input field
                      className={styles.toggleEye}
                      aria-label={
                        this.state.isPasswordVisibleForm1
                          ? "Hide password"
                          : "Show password"
                      }
                    >
                      {/* Conditionally render the icon */}
                      {this.state.isPasswordVisibleForm1 ? (
                        <span role="img" aria-label="Hide password"   style={{opacity:  0.3}}>
                          <IoEye size={21} />
                        </span>
                      ) : (
                        <span role="img" aria-label="Show password"  style={{opacity:  0.3}}>
                          <IoMdEyeOff size={21} />
                        </span>
                      )}
                    </button>
                  </div>
              
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <label htmlFor="password2">Confirm New Password</label>
                    <input
                      type={
                        this.state.isPasswordVisibleForm2 ? "text" : "password"
                      }
                      placeholder="New Password"
                      value={this.state.password2}
                      onChange={(event) =>
                        this.setState({ password2: event.target.value })
                      }
                    />
                    <button
                      type="button"
                      onClick={this.handleToggleForm2Password}
                      className={styles.toggleEye}
                      aria-label={
                        this.state.isPasswordVisibleForm2
                          ? "Hide password"
                          : "Show password"
                      }
                    >
                      {this.state.isPasswordVisibleForm2 ? (
                        <span role="img" aria-label="Hide password" style={{opacity:  0.3}}>
                          <IoEye size={21} />
                        </span>
                      ) : (
                        <span role="img" aria-label="Show password" style={{opacity:  0.3}}>
                          <IoMdEyeOff size={21}     />
                        </span>
                      )}
                    </button>
                  </div>

                  <div>
                    <button
                      className={"btn primary"}
                      onClick={(e) =>
                        this.resetPassword(
                          e,
                          this.props.location.search,
                          this.state.password2
                        )
                      }
                    >
                      RESET
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ForgotPassword;
